export default "__VITE_ASSET__D3S7Zgq$__"